import fixValidationQueryKey from "./fixValidationQueryKey";
import fixCouponQueryKey from "./fixCouponQueryKey";

export default function pickQueryFix(type) {
    if (type === "coupon") {
        return fixCouponQueryKey;
    } else {
        return fixValidationQueryKey;
    }
}